import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { PayPalButton } from 'react-paypal-button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { sendToGoogleSheet, sendEmailNotification, sendThankyouEmail } from '../functions/api_calls'
import { CLIENT_ID } from '../functions/constants'

const DonationFormStyle = styled.div`
  margin: 10px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    margin-bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    h4, p {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
`

const DonationForm = (props) => {
  const [donationValue, setDonationValue] = useState('10');
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [donationType, setDonationType] = useState('general');

  useEffect(() => {
    if (document.querySelector('#donationInput')) {
      document.querySelector('#donationInput').defaultValue = '10';
    }
  })
  
  
  const paypalOptions = {
    clientId: CLIENT_ID,
    intent: 'capture',
    currency: 'EUR'
  }
  
  const buttonStyles = {
    layout: 'vertical',
    shape: 'rect',
    tagline: false,
    color: 'silver'
  }

  const handleChange = (e) => {
    e.persist();
    const donation = e.target.value;
    setDonationValue(donation);
  }

  const processPaymentDetails = (paymentData) => {
    setPaymentStatus(true);
    console.log('Payment Info:');
    console.log(paymentData);
    
    setPaymentDetails({
      email: paymentData.payer.email_address,
      name: `${paymentData.payer.name.given_name} ${paymentData.payer.name.surname}`,
      donation: paymentData.purchase_units[0].amount.value
    });

    try {
      sendEmailNotification(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }

    try {
      sendThankyouEmail(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }

    try {
      sendToGoogleSheet(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }
  }

  if (!paymentStatus) {
    return (
      <DonationFormStyle>
        <form>
          <h4>I'd like to donate</h4>
          <div className="field has-addons">
            <p className="control">
              <span className="button is-static">
                €
              </span>
            </p>
            <p className="control">
              <input className="input" id='donationInput' type="number" placeholder='10' onChange={handleChange} style={{width: '80px'}} />
            </p>
          </div>
        </form>
        <div>
          {donationValue === '' || donationValue < 1 ? '' :
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <PayPalButton
                paypalOptions={paypalOptions}
                buttonStyles={buttonStyles}
                amount={donationValue}
                onPaymentSuccess={(data) => processPaymentDetails(data)}    
                onPaymentError={(msg) => console.log(msg)}
                onPaymentCancel={(data) => console.log(data)}
              />
            </div>
          }
        </div>
      </DonationFormStyle>
    )
  } else if (paymentStatus) {
    return (
      <DonationFormStyle>
        <span className='can-green' style={{fontSize: '4em'}}><FontAwesomeIcon icon={faCheck} /></span>
        <h3 style={{marginBottom: '5px'}}>Thank you for your donation, </h3>
        <h3 style={{marginTop: '0px'}} className='can-green'>{paymentDetails.name || 'guest'}</h3>
        <p style={{textAlign: 'center'}}>
          Your support allows us to continue to protect and regenerate our forests.
          A confirmation email has been sent to {paymentDetails.email}.
        </p>
      </DonationFormStyle>
    )
  }
}

export default DonationForm